import { render, staticRenderFns } from "./proIpage.vue?vue&type=template&id=dc907236&scoped=true"
import script from "./proIpage.vue?vue&type=script&lang=js"
export * from "./proIpage.vue?vue&type=script&lang=js"
import style0 from "./proIpage.vue?vue&type=style&index=0&id=dc907236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc907236",
  null
  
)

export default component.exports